import { colors } from 'hui';
import React, { useContext } from 'react';
import styled from 'styled-components';
import HeaderContext from '../../HeaderContext';
import HoverMenu from '../hover-menu';
import MenuContents from './menu-contents';

//show on desktop and tablet - mobile view has the login menu options in main mobile menu
const Desktop = styled.div<{ breakPoint: string }>`
  display: inline-block;
  margin-left: 20px;

  @media (max-width: ${props => props.breakPoint}) {
    display: none;
  }
`;

const UsernameLink = styled.a`
  font-size: 15px;
  text-decoration: none;
  color: ${colors.tint2};
  display: inline-block;
  cursor: pointer;

  &:hover,
  &:visited {
    color: #555;
  }
`;

const Avatar = styled.img`
  border-radius: 100%;
  width: 26px;
  height: 26px;
  vertical-align: middle;
  cursor: pointer;
`;

const UnreadMessagesCircle = styled.span`
  position: absolute;
  top: -6px;
  width: 13px;
  height: 13px;
  right: -4px;
  display: block;
  margin: 0;
  background-color: ${colors.danger};
  border: 2px solid ${colors.tint6};
  border-radius: 100%;
`;

const Wrap = styled.div`
  position: relative;
  display: inline;
  margin-right: 10px;
`;

const LoggedIn: React.FC<{}> = () => {
  const { breakPoint, loginData } = useContext(HeaderContext);
  return (
    <Desktop breakPoint={breakPoint}>
      <HoverMenu
        isShiftLeft
        hasFancyArrow
        menuItem={
          <UsernameLink>
            <Wrap>
              <Avatar src={`/creative/users/${loginData.user_thumbnail!}/140x140.jpg`} />
              {loginData.number_messages! > 0 && <UnreadMessagesCircle />}
            </Wrap>
          </UsernameLink>
        }
      >
        <MenuContents />
      </HoverMenu>
    </Desktop>
  );
};

export default LoggedIn;
